import CreateMessage from "./Create";
import DistributorMessageList from "./List";

export { CreateMessage, DistributorMessageList };
